import React from 'react';
import { Grid,Box,Typography,Tooltip} from '@mui/material';

const TOKCart = (props:any) => {
    let{kr,num}=props || {};
    let{name}=kr || {};

  return (  
    
    <Grid container boxShadow={4} bgcolor={'white'} borderRadius={4} p={2} width={'100%'} >
        <Grid item xs={12}  >
        <Grid container >
        <Grid item xs={12}  >
        <Box 
        display={'flex'} 
        width={'100%'}
        flexDirection={'row-reverse'}
        justifyContent={'start'} > 
        
        <Box 
        display={'flex'} 
        width={'100%'}
       >
        <Typography px={1}  variant='body1' fontSize={'14px'}  fontWeight={900} >
        نتیجه {num + 1} :
        </Typography>{
        name.length > 52 ? <Tooltip  sx={{ fontSize: '13px !important' }} title={name}>
        <Typography  variant='body1'sx={{ fontSize: '13px !important', fontWeight:'700',color: 'black',cursor:'pointer'}}>{name.slice(0,52)}</Typography>
        </Tooltip>:<Typography  sx={{ fontSize: '13px !important',fontWeight:'700', color: 'black',cursor:'pointer'}}>
              {
                 name
              }
            </Typography>
       }
        </Box>
        </Box>
        </Grid>
      </Grid>
        </Grid>
        <Grid item xs={12}  >
        <Box 
        display={'flex'} 
        width={'100%'}
        flexDirection={'row-reverse'}
        justifyContent={'space-around'} > 
        <Box 
        display={'flex'} 

        justifyContent={'end'} boxShadow={5} borderRadius={'50%'}  bgcolor={'#00387C'} textAlign={'center'}>
        </Box>
      </Box>
        </Grid>
        <Grid xs={12}>
        <Box  display={'flex'} alignItems={'center'} justifyContent={'space-between'} textAlign={'center'}>   
      </Box>
        </Grid>
   </Grid>
  )
}

export default TOKCart